import { module } from 'modujs';
import modularLoad from '../modules/ModularLoad';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 800,
            transitions: {
                detailTransition: {},
                langTransition:{}
            }
        });

        this.load.on('loading', (transition, oldContainer, link) => {

            if(document.getElementsByTagName('html')[0].getAttribute('data-survey-valid') != 'true') {
                if(html.getAttribute('data-template') === 'survey' && link !== undefined && (html.getAttribute('data-confirm') === 'false' || html.getAttribute('data-confirm') === null)) {
                    this.confirmTransition(link.getAttribute('href'));
                    this.load.blocked = true;
                    return;
                }
            }
            
            html.classList.remove('has-scrolled');
            html.classList.remove('has-footer-widget-open');
            html.classList.remove('has-widget-user-open');
            html.classList.remove('-footer');
            html.classList.remove('has-menu-tools-open');
            html.classList.remove('has-search-open');
            html.setAttribute('data-ui','');

            if(transition === 'langTransition') {
                html.classList.add('has-menu-lang-open-is-closing');

                setTimeout(() => {

                    html.classList.remove('has-menu-lang-open');
                    html.classList.remove('has-menu-lang-open-is-closing');
                    
                }, 600)
            }

            setTimeout(() => {
                html.classList.remove('is-animated');
                html.classList.remove('has-nav-open');
            }, 200);

            this.load.blocked = false;
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            this.call('destroyEvents','Cursor');
            this.call('initEvents','Cursor');

            setTimeout(() => {
                html.classList.add('is-animated');
            }, 1200);

            html.setAttribute('data-theme',newContainer.getAttribute('data-theme'));
            html.setAttribute('data-container-size',newContainer.getAttribute('data-container-size'));
        });
    }

    confirmTransition(href) {

        if(confirm(this.getData('confirm-text'))) {
            html.setAttribute('data-confirm','true');
            this.load.blocked = false;
            // window.location = href;
            this.goto(href)
        } else {
            html.setAttribute('data-confirm','false');
        }

    }

    goto(page) {
        this.load.goTo(page);
    }
}
